
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3h37U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $koEBx = parcelRequire("koEBx");


var $d7j1D = parcelRequire("d7j1D");


var $2lPWP = parcelRequire("2lPWP");


var $8MmI7 = parcelRequire("8MmI7");

const $706a470437238efe$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new (0, $2lPWP.JSONTransformer)();
        $[0] = t0;
    } else t0 = $[0];
    const transformer = t0;
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)("chromeless", features);
    let t1;
    if ($[1] !== onChange) {
        t1 = (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        };
        $[1] = onChange;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== defaultValue || $[4] !== isDisabled || $[5] !== preset || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onChange: t1
        }));
        $[3] = defaultValue;
        $[4] = isDisabled;
        $[5] = preset;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $cozmU.useMemo)(()=>new (0, $2lPWP.JSONTransformer)(), []);
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    }));
};
module.exports["ChromelessEditor"] = $706a470437238efe$export$5252bd745392dcde;

});

parcelRegister("8MmI7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dVPAB = parcelRequire("dVPAB");


var $9Qt8c = parcelRequire("9Qt8c");


var $k1GzU = parcelRequire("k1GzU");

const $d7b2d2844e329581$export$cdae2f05238f63a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (appearance, features)=>{
    const $ = (0, $bDgLe.c)(5);
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    let t0;
    if ($[0] !== appearance || $[1] !== memoisedFeatures) {
        t0 = (builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures);
        $[0] = appearance;
        $[1] = memoisedFeatures;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== memoisedFeatures) {
        t1 = [
            memoisedFeatures
        ];
        $[3] = memoisedFeatures;
        $[4] = t1;
    } else t1 = $[4];
    const preset = (0, $dVPAB.usePreset)(t0, t1);
    return preset;
} : (appearance, features)=>{
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    const preset = (0, $dVPAB.usePreset)((builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};
module.exports["usePresetByFeatures"] = $d7b2d2844e329581$export$cdae2f05238f63a2;

});

parcelRegister("9Qt8c", function(module, exports) {

var $3HCXM = parcelRequire("3HCXM");


var $1171P = parcelRequire("1171P");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $bkj40 = parcelRequire("bkj40");


var $e6Dq9 = parcelRequire("e6Dq9");


var $1ZhW4 = parcelRequire("1ZhW4");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $5tMpU = parcelRequire("5tMpU");


var $5HQgD = parcelRequire("5HQgD");


var $hFvHs = parcelRequire("hFvHs");


var $hYOOW = parcelRequire("hYOOW");


var $hHtwA = parcelRequire("hHtwA");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $d1HsG = parcelRequire("d1HsG");

const $7be6a40f5b04921d$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $7be6a40f5b04921d$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $7Upsh.default)).maybeAdd((0, $fKdaf.blockTypePlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $lK9Pz.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $hYOOW.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $d1HsG.typeAheadPlugin)).maybeAdd((0, $hHtwA.quickInsertPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $grjTL.textFormattingPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $gkbos.textColorPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $hFvHs.listPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $1171P.toolbarListsIndentationPlugin),
        // adds the list indentation section to the toolbar
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)).add((0, $1ZhW4.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $e273U.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $2QN3e.decorationsPlugin)) // required for floating toolbar
    .add((0, $5tMpU.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $3HCXM.hyperlinkPlugin),
        // allows for hyper link to be added to text
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $e6Dq9.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $bkj40.default),
        {}
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $5HQgD.insertBlockPlugin),
        // this controls the last set of toolbar insertions(link, codeblock and quote block)
        {
            appearance: appearance
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.insertBlock));
};
module.exports["createPreset"] = $7be6a40f5b04921d$export$b956d067c5bcf6b;

});

parcelRegister("k1GzU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $12df64cf02a24e7a$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $12df64cf02a24e7a$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $cozmU.useRef)();
    const shouldUpdate = !$12df64cf02a24e7a$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};
module.exports["useMemoisedFeatures"] = $12df64cf02a24e7a$export$67693d05a6051899;

});

parcelRegister("dYD92", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $g8bbY = parcelRequire("g8bbY");


var $d7j1D = parcelRequire("d7j1D");


var $iMnC5 = parcelRequire("iMnC5");


var $8MmI7 = parcelRequire("8MmI7");

const $05cce7c0e751361c$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)("comment", features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const element = wrapperRef.current;
            if (!element) return;
            return (0, $cbY7C.bind)(element, {
                type: "keypress",
                listener: $05cce7c0e751361c$var$_temp
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== editorApi?.core.actions || $[3] !== onSave) {
        t2 = onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined;
        $[2] = editorApi?.core.actions;
        $[3] = onSave;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onCancel) {
        t3 = onCancel ? ()=>onCancel() : undefined;
        $[5] = onCancel;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== editorApi?.core.actions || $[8] !== onChange) {
        t4 = ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        };
        $[7] = editorApi?.core.actions;
        $[8] = onChange;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== defaultValue || $[11] !== isDisabled || $[12] !== preset || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onSave: t2,
            onCancel: t3,
            onChange: t4
        })));
        $[10] = defaultValue;
        $[11] = isDisabled;
        $[12] = preset;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)('comment', features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const element = wrapperRef.current;
        if (!element) return;
        return (0, $cbY7C.bind)(element, {
            type: 'keypress',
            listener: (e)=>e.stopImmediatePropagation()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onSave: onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined,
        onCancel: onCancel ? ()=>onCancel() : undefined,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        }
    })));
};
function $05cce7c0e751361c$var$_temp(e) {
    return e.stopImmediatePropagation();
}
module.exports["CommentEditor"] = $05cce7c0e751361c$export$4153d6fbc2386422;

});

parcelRegister("qeywr", function(module, exports) {
/* adf-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jTt8P = parcelRequire("jTt8P");


var $eNbr2 = parcelRequire("eNbr2");


var $cXtTj = parcelRequire("cXtTj");


var $lNvN4 = parcelRequire("lNvN4");


var $iDrrr = parcelRequire("iDrrr");


var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");


var $6BvLK = parcelRequire("6BvLK");

var $4BZVV = parcelRequire("4BZVV");

var $HHXWG = parcelRequire("HHXWG");

var $fTOZ6 = parcelRequire("fTOZ6");

var $9XnlZ = parcelRequire("9XnlZ");

var $gFIer = parcelRequire("gFIer");

var $67Hav = parcelRequire("67Hav");


var $a005x = parcelRequire("a005x");


var $4G9b9 = parcelRequire("4G9b9");


var $35FNt = parcelRequire("35FNt");


var $2Ni8p = parcelRequire("2Ni8p");

const $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA = Object.freeze({});
const $108ec996f4c4b6a3$var$baseRendererFontStyles = null;
const $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles = (productHandlerEntry)=>{
    const wrapProductHandler = (productHandler)=>{
        return (extensionProps, doc)=>{
            const result = productHandler(extensionProps, doc);
            if (result == null) return result;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            , {
                style: {
                    '--ak-renderer-base-font-size': '16px'
                },
                className: (0, $hekY6.default)([
                    "_4ya3eEb9Wl"
                ])
            }, result);
        };
    };
    return typeof productHandlerEntry === 'function' ? wrapProductHandler(productHandlerEntry) : {
        ...productHandlerEntry,
        render: wrapProductHandler(productHandlerEntry.render)
    };
};
const $108ec996f4c4b6a3$var$filterInvalidMediaUrls = (appDomainName, egressServices, adfDocument)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $HHXWG.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $jTt8P.traverse)(adfDocument, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : adfDocument,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $108ec996f4c4b6a3$var$useSupportsMedia = ()=>{
    try {
        (0, $lNvN4.useMediaClient)();
        return true; // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
}; // Module-level cache keyed on `cloudId:userId` — created once per page load, reused across all extensions
const $108ec996f4c4b6a3$var$emojiProviderCache = new Map();
const $108ec996f4c4b6a3$export$2d71cf17ec7ade05 = (cloudId, userId)=>{
    if (!(0, $iDrrr.fg)('platform_forge_ui_custom_emoji_ui_kit_adf_renderer') || !cloudId) return undefined;
    const cacheKey = `${cloudId}:${userId ?? ''}`;
    const cached = $108ec996f4c4b6a3$var$emojiProviderCache.get(cacheKey);
    if (cached) return cached;
    const emojiProvider = (0, $4G9b9.getEmojiProvider)(cloudId, userId ?? null);
    $108ec996f4c4b6a3$var$emojiProviderCache.set(cacheKey, emojiProvider);
    return emojiProvider;
}; // Reads the current value of a provider off a ProviderFactory without leaving a lingering
// subscription. Returns `undefined` when the factory or provider is absent.
const $108ec996f4c4b6a3$var$getProviderFromFactory = (factory, name)=>{
    if (!factory) return undefined;
    const noop = ()=>{};
    const provider = factory.subscribe(name, noop);
    factory.unsubscribe(name, noop);
    return provider;
}; // Reads a single provider off the first supplied source factory that exposes it, returning a
// spreadable `{ [name]: provider }` fragment (or `undefined` when no source has it). When several
// sources expose the same provider, earlier sources win.
const $108ec996f4c4b6a3$var$pickProvider = (name, ...sources)=>{
    const source = sources.find((factory)=>factory?.hasProvider(name));
    return source ? {
        [name]: $108ec996f4c4b6a3$var$getProviderFromFactory(source, name)
    } : undefined;
}; // Builds the single ProviderFactory handed to the nested renderer: the custom emoji provider passed
// in directly, plus the task-decision and context-identifier providers copied off the host factory
// (never mutating it) so action items inside a bodied macro body can persist their checked state.
const $108ec996f4c4b6a3$var$mergeNestedDataProviders = (hostDataProviders, emojiProvider)=>(0, $eNbr2.default).create({
        ...emojiProvider ? {
            emojiProvider: emojiProvider
        } : {},
        // Action items (checklist toggle) need BOTH providers to persist their checked state:
        // - taskDecisionProvider performs the actual write (toggleTask -> backend mutation).
        // - contextIdentifierProvider supplies the objectId that ResourcedTaskItem resolves into the
        //   objectAri key for that write. Without it the provider has no target to persist against, so
        //   ResourcedTaskItem falls back to local-only state and the toggle is lost on refresh.
        ...$108ec996f4c4b6a3$var$pickProvider('taskDecisionProvider', hostDataProviders),
        ...$108ec996f4c4b6a3$var$pickProvider('contextIdentifierProvider', hostDataProviders)
    });
const $108ec996f4c4b6a3$export$a504d7ec22d4b3f4 = ({ bridge: bridge, cloudId: cloudId, customBridgeMethods: customBridgeMethods, customBridge: customBridge, getContextToken: getContextToken, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, dataProviders: hostDataProviders, userId: userId })=>{
    const dataProviderFactory = $108ec996f4c4b6a3$var$mergeNestedDataProviders(hostDataProviders, $108ec996f4c4b6a3$export$2d71cf17ec7ade05(cloudId, userId));
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$export$c334f442ba514f7d, {
            bridge: bridge,
            cloudId: cloudId,
            dataProviders: dataProviderFactory,
            getContextToken: getContextToken,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            isEditing: isEditing,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId,
            ...props
        });
}; /**
    * The AdfRenderer component provides a way to render a valid ADF document, using the same renderer that Atlassian uses internally to render ADF content in Confluence pages, Jira work items, and so on.
    * It allows you to replace node types that are unsupported in the context of a Forge app with replacement content, or remove them entirely.
    * See [Atlassian Document Format](/cloud/jira/platform/apis/document/structure/) for information on valid nodes.
    *
    * This component uses [@atlaskit/renderer](https://www.npmjs.com/package/@atlaskit/renderer) under the hood.
    *
    * Visit [Renderer editor](https://atlaskit.atlassian.com/examples/editor/renderer/basic) for a comprehensive list of different ADF document examples
    */ 
const $108ec996f4c4b6a3$var$makeExtensionHandlers = ({ bridge: bridge, cloudId: cloudId, embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers = {}, userId: userId })=>{
    const forgeMacroHandler = (props)=>{
        const { localId: localId, parameters: parameters } = props;
        const isMigrated = parameters?.isMigrated;
        const autoConvertLink = parameters?.autoConvertLink;
        const isInline = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && parameters?.layout === 'inlineExtension'; // Extract config from extension parameters (can be in guestParams or config)
        const config = parameters.guestParams || parameters.config;
        const extensionPayload = {
            config: config,
            isEditing: isEditing
        };
        const embeddedMacroContext = parameters.embeddedMacroContext;
        const extensionId = parameters.extensionId;
        if (!embeddedMacroContext || !extensionId) return null;
        const { accountId: accountId, cloudId: cloudId, contextIds: contextIds, extensionData: extensionData } = embeddedMacroContext;
        const augmentedExtensionData = {
            ...extensionData,
            autoConvertLink: autoConvertLink
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BZVV.EmbeddedMacroRenderer), {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: augmentedExtensionData,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA,
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            getContextToken: getContextToken,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? 'UIKit' : undefined
        });
    };
    const baseExtensionHandlers = {
        'com.atlassian.ecosystem': forgeMacroHandler
    };
    const productMacroCoreHandlerEntry = productExtensionHandlers['com.atlassian.confluence.macro.core'];
    const productMacroCoreHandler = productMacroCoreHandlerEntry && (0, $iDrrr.fg)('platform_forge_nested_macro_font_fix') ? $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles(productMacroCoreHandlerEntry) : productMacroCoreHandlerEntry;
    const renderProductMacroCoreHandler = typeof productMacroCoreHandler === 'function' ? productMacroCoreHandler : productMacroCoreHandler?.render;
    const renderProductMacroCore = (props, doc)=>renderProductMacroCoreHandler?.(props, doc) ?? null;
    const renderProductMacroCoreWithAnalytics = (props, doc)=>{
        const result = renderProductMacroCore(props, doc);
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMacroCore",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const shouldTrackNestingAnalytics = (0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false);
    const renderProductCoreHandlerOrForgeMacroHandler = (props, doc)=>{
        if (forgeMacroExtensions !== undefined) {
            if (forgeMacroExtensions === null) return null;
            const migratedForgeExtension = (0, $35FNt.getMigratedForgeMacroExtension)(forgeMacroExtensions, props.extensionKey);
            if (migratedForgeExtension) {
                const parameters = (0, $35FNt.createForgeParametersForConnectMacro)({
                    accountId: userId,
                    cloudId: cloudId,
                    extension: migratedForgeExtension,
                    extensionData: extensionData,
                    productContextIds: productContextIds,
                    props: props
                });
                if (!parameters) return null;
                const result = forgeMacroHandler({
                    ...props,
                    parameters: {
                        ...parameters,
                        isMigrated: shouldTrackNestingAnalytics ? true : undefined
                    }
                }, doc);
                return result;
            }
            if (!productMacroCoreHandler) return null;
            return shouldTrackNestingAnalytics ? renderProductMacroCoreWithAnalytics(props, doc) : renderProductMacroCore(props, doc);
        }
        if (!productMacroCoreHandler) return null;
        return shouldTrackNestingAnalytics ? renderProductMacroCoreWithAnalytics(props, doc) : renderProductMacroCore(props, doc);
    };
    const productMigrationHandler = productExtensionHandlers?.['com.atlassian.confluence.migration'];
    const renderProductMigrationHandler = typeof productMigrationHandler === 'function' ? productMigrationHandler : productMigrationHandler?.render;
    const renderProductMigrationWithAnalytics = (props, doc)=>{
        const result = renderProductMigrationHandler?.(props, doc) ?? null;
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMigration",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const productMigrationHandlerWithAnalytics = productMigrationHandler && shouldTrackNestingAnalytics ? renderProductMigrationWithAnalytics : productMigrationHandler;
    if (!(0, $cXtTj.default).getExperimentValue('platform_forge_uikit_render_migrated_macro', 'isEnabled', false)) return {
        ...baseExtensionHandlers,
        ...productMacroCoreHandler && {
            'com.atlassian.confluence.macro.core': productMacroCoreHandler
        },
        ...productMigrationHandlerWithAnalytics && {
            'com.atlassian.confluence.migration': productMigrationHandlerWithAnalytics
        }
    };
    return {
        ...baseExtensionHandlers,
        'com.atlassian.confluence.macro.core': renderProductCoreHandlerOrForgeMacroHandler,
        ...productMigrationHandlerWithAnalytics && {
            'com.atlassian.confluence.migration': productMigrationHandlerWithAnalytics
        }
    };
};
const $108ec996f4c4b6a3$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $108ec996f4c4b6a3$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const imagesEgressService = (0, $gFIer.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $gFIer.useEgressPermissionService)('MEDIA', egress);
    const { bridge: bridge, cloudId: cloudId, customBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, dataProviders: dataProviders, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, userId: userId } = props;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $67Hav.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: adfDocument, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    const isNestedExtensionTableWidthFixEnabled = (0, $iDrrr.fg)('platform_forge_nested_table_width_fix'); // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : adfDocument;
    const { nestedExtensionTableMinWidth: nestedExtensionTableMinWidth } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isNestedExtensionTableWidthFixEnabled ? (0, $2Ni8p.getNestedExtensionTableAnalysis)(doc) : {
            containsExtension: false,
            nestedExtensionTableMinWidth: undefined
        }, [
        doc,
        isNestedExtensionTableWidthFixEnabled
    ]);
    const { extensionContainerWidth: extensionContainerWidth, rendererContainerRef: rendererContainerRef } = (0, $2Ni8p.useForgeExtensionContainerWidth)(nestedExtensionTableMinWidth !== undefined);
    const nestedExtensionTableWidth = (0, $2Ni8p.getNestedExtensionTableWidth)(nestedExtensionTableMinWidth, extensionContainerWidth);
    const nestedExtensionRendererMinWidth = nestedExtensionTableWidth ? nestedExtensionTableWidth + (0, $2Ni8p.NESTED_EXTENSION_TABLE_INLINE_START_OFFSET) : undefined;
    const rendererWidth = Math.max(extensionContainerWidth ?? 0, nestedExtensionRendererMinWidth ?? 0);
    (0, $2Ni8p.useNestedExtensionTableWidth)(rendererContainerRef, nestedExtensionTableWidth);
    const rendererContainerStyle = rendererWidth ? {
        width: `${rendererWidth}px`
    } : undefined;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>doc ? $108ec996f4c4b6a3$var$filterInvalidMediaUrls(appDomainName, [
            imagesEgressService,
            mediaEgressService
        ], doc) : {
            filteredDocument: undefined,
            invalidUrls: []
        }, [
        appDomainName,
        doc,
        imagesEgressService,
        mediaEgressService
    ]);
    const rendererDocument = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>filteredDocument && nestedExtensionTableWidth ? (0, $2Ni8p.resizeNestedExtensionTables)(filteredDocument, nestedExtensionTableWidth) : filteredDocument, [
        filteredDocument,
        nestedExtensionTableWidth
    ]);
    if (!doc || !rendererDocument) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const renderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        ...adfRendererProps,
        ...isNestedExtensionTableWidthFixEnabled && {
            appearance: 'full-width',
            UNSTABLE_allowTableAlignment: true,
            UNSTABLE_allowTableResizing: true,
            allowFixedColumnWidthOption: true
        },
        allowCustomPanels: (0, $iDrrr.fg)('confluence_fix_migrated_macro_inline_rendering'),
        dataProviders: dataProviders,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $9XnlZ.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: rendererDocument,
        extensionHandlers: $108ec996f4c4b6a3$var$makeExtensionHandlers({
            bridge: bridge,
            cloudId: cloudId,
            embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            isEditing: isEditing,
            getContextToken: getContextToken,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId
        })
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BvLK.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), isNestedExtensionTableWidthFixEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: rendererContainerRef,
        style: rendererContainerStyle
    }, renderer) : renderer);
};
module.exports["makeADFRenderer"] = $108ec996f4c4b6a3$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $108ec996f4c4b6a3$export$c334f442ba514f7d;

});

parcelRegister("4BZVV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fTCJP = parcelRequire("fTCJP");


var $d5gEx = parcelRequire("d5gEx");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $4o0zT = parcelRequire("4o0zT");


var $f53nH = parcelRequire("f53nH");


var $ix7El = parcelRequire("ix7El");


var $lCGo1 = parcelRequire("lCGo1");


var $4v1ex = parcelRequire("4v1ex");


var $lWtBU = parcelRequire("lWtBU");


var $8BldL = parcelRequire("8BldL");


var $iUEMs = parcelRequire("iUEMs");


var $8yKod = parcelRequire("8yKod");


var $kKOjD = parcelRequire("kKOjD");


var $gKVSw = parcelRequire("gKVSw");


var $6FQr4 = parcelRequire("6FQr4");


var $DIyeF = parcelRequire("DIyeF");


var $cIUmi = parcelRequire("cIUmi");

let $931bc75652dbffc6$var$cachedPostRobotSend;

const $931bc75652dbffc6$var$getPostRobotSend = ()=>{
    if ($931bc75652dbffc6$var$cachedPostRobotSend !== undefined) $931bc75652dbffc6$var$cachedPostRobotSend;
    if (typeof window === 'undefined') return null;
    try {
        $931bc75652dbffc6$var$cachedPostRobotSend = (parcelRequire("9rzZK")).postRobotSend;
    } catch (_) {
        $931bc75652dbffc6$var$cachedPostRobotSend = null;
    }
    return $931bc75652dbffc6$var$cachedPostRobotSend;
};
// Container for supporting inline macros
const $931bc75652dbffc6$var$MacroExtensionContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isInline: isInline, children: children } = t0;
    const inlineEnabled = (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") && isInline;
    const t1 = inlineEnabled ? "inline-block" : "block";
    const t2 = inlineEnabled ? "middle" : "";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            display: t1,
            verticalAlign: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-forge-extension-container": "true",
            "data-testid": "ForgeExtensionContainer",
            style: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ isInline: isInline, children: children })=>{
    const inlineEnabled = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && isInline;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-forge-extension-container": "true",
        "data-testid": "ForgeExtensionContainer",
        style: {
            display: inlineEnabled ? 'inline-block' : 'block',
            verticalAlign: inlineEnabled ? 'middle' : ''
        }
    }, children);
};
const $931bc75652dbffc6$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lCGo1.Loader), null);
};
const $931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionId: extensionId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId || $[2] !== source) {
        t1 = ()=>{
            const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: source,
                extensionKey: extensionKey
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = source;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionId: extensionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    (0, $cozmU.useEffect)(()=>{
        const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: source,
            extensionKey: extensionKey
        });
    }, [
        createAnalyticsEvent,
        extensionId,
        source
    ]);
    return null;
};
const $931bc75652dbffc6$var$EmbeddedMacroRendererInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    "xen:macro"
                ]
            }
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== contextIds) {
        t1 = {
            contextIds: contextIds,
            filter: t0
        };
        $[1] = contextIds;
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)(t1);
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)("platform_validate_embedded_macro_installation");
    if (loading || !queryCompleted) {
        let t2;
        if ($[3] !== loadingComponent) {
            t2 = $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
            $[3] = loadingComponent;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    if (notInstalled) {
        let t2;
        if ($[5] !== extensionId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
                extensionId: extensionId
            });
            $[5] = extensionId;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? "CustomUI" : "UIKit");
    let getContextToken = props.getContextToken;
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)("forge-ui-bridge-core-reset")) {
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? embeddedMacroParentType === "CustomUI" && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? "CustomUI" : "UIKit";
    const t2 = getContextToken;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type");
        $[7] = t3;
    } else t3 = $[7];
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: t2,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !t3,
        embeddedMacroParentType: (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $4o0zT.isExperimentEnabled)("platform_forge_nesting_analytics");
        $[8] = t4;
    } else t4 = $[8];
    const shouldTrackNestingAnalytics = t4;
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)("platform_forge_ui_uikit_modal_in_custom_ui_parent")) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend();
        let t5;
        if ($[9] !== customBridge?.setEmbeddedMacroModalForgeDoc) {
            t5 = (0, $iDrrr.fg)("forge-ui-bridge-core-reset") && customBridge?.setEmbeddedMacroModalForgeDoc;
            $[9] = customBridge?.setEmbeddedMacroModalForgeDoc;
            $[10] = t5;
        } else t5 = $[10];
        const uiKitModalForwarder = t5;
        const forwarder = uiKitModalForwarder ? (t6)=>{
            const { data: data } = t6;
            return uiKitModalForwarder(undefined, data);
        } : (0, $iUEMs.createMessageForwarder)("setEmbeddedMacroModalForgeDoc", {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? "",
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? "",
            id: extension?.id ?? "",
            installationId: extension?.installationId
        });
        let t7;
        if ($[11] !== embeddedParentModalKey || $[12] !== forwarder) {
            t7 = {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            };
            $[11] = embeddedParentModalKey;
            $[12] = forwarder;
            $[13] = t7;
        } else t7 = $[13];
        let t8;
        if ($[14] !== extensionId || $[15] !== shouldTrackNestingAnalytics) {
            t8 = shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
                extensionId: extensionId
            });
            $[14] = extensionId;
            $[15] = shouldTrackNestingAnalytics;
            $[16] = t8;
        } else t8 = $[16];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: t7
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    let t5;
    if ($[17] !== extensionId || $[18] !== shouldTrackNestingAnalytics) {
        t5 = shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        });
        $[17] = extensionId;
        $[18] = shouldTrackNestingAnalytics;
        $[19] = t5;
    } else t5 = $[19];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
} : (props)=>{
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)({
        contextIds: contextIds,
        filter: [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    'xen:macro'
                ]
            }
        ]
    });
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)('platform_validate_embedded_macro_installation');
    if (loading || !queryCompleted) return $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
    if (notInstalled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
        extensionId: extensionId
    });
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? 'CustomUI' : 'UIKit');
    let getContextToken = props.getContextToken;
    // createGetContextToken is the FAUS version of useGetContextToken — it is used for embedded
    // macros with a Custom UI bodied parent.
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)('forge-ui-bridge-core-reset')) {
        // For embedded macros with a UI Kit parent, getContextToken is
        // passed in by Confluence rather than constructed here.
        // We inject the embedded macro's
        // contextIds, extension, and localId — so bridge calls that uses getContextToken(invoke,
        // realtime, etc.) use the embedded macro's context, not the parent's.
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'CustomUI' && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? 'CustomUI' : 'UIKit';
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: getContextToken,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !(0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type'),
        embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    const shouldTrackNestingAnalytics = (0, $4o0zT.isExperimentEnabled)('platform_forge_nesting_analytics');
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent')) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend(); // This prop is used to determine if the embedded macro is rendered within a Custom UI macro. Since the EmbeddedMacroRenderer is only used for rendering macros within Custom UI, we can set this to true.
        const uiKitModalForwarder = (0, $iDrrr.fg)('forge-ui-bridge-core-reset') && customBridge?.['setEmbeddedMacroModalForgeDoc'];
        const forwarder = uiKitModalForwarder ? ({ data: data })=>uiKitModalForwarder(undefined, data) : (0, $iUEMs.createMessageForwarder)('setEmbeddedMacroModalForgeDoc', {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? '',
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? '',
            id: extension?.id ?? '',
            installationId: extension?.installationId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            }
        }, shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionId: extensionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
};
const $931bc75652dbffc6$export$329644bef0dce3f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.isInline || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
            isInline: props.isInline
        }, t0));
        $[2] = props.isInline;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
        isInline: props.isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props)));
};
module.exports["EmbeddedMacroRenderer"] = $931bc75652dbffc6$export$329644bef0dce3f7;

});

parcelRegister("fTCJP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $5xQdV = parcelRequire("5xQdV");

const $7e5b733cbcedd00c$export$2067d1940da125b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== embeddedMacroParentType || $[2] !== embeddedMacroType || $[3] !== isInline || $[4] !== isMigrated) {
        t1 = ()=>({
                forgeUIAttributes: {
                    contentId: contentId,
                    isEmbeddedMacro: true,
                    ...isInline !== undefined ? {
                        isInline: isInline
                    } : {},
                    ...isMigrated ? {
                        isMigrated: isMigrated
                    } : {},
                    embeddedMacroParentType: embeddedMacroParentType,
                    embeddedMacroType: embeddedMacroType
                }
            });
        t2 = [
            contentId,
            isInline,
            isMigrated,
            embeddedMacroParentType,
            embeddedMacroType
        ];
        $[0] = contentId;
        $[1] = embeddedMacroParentType;
        $[2] = embeddedMacroType;
        $[3] = isInline;
        $[4] = isMigrated;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    const data = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[7] !== children || $[8] !== data) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, children);
        $[7] = children;
        $[8] = data;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children })=>{
    const data = (0, $5xQdV.useMemoOne)(()=>({
            forgeUIAttributes: {
                contentId: contentId,
                isEmbeddedMacro: true,
                ...isInline !== undefined ? {
                    isInline: isInline
                } : {},
                ...isMigrated ? {
                    isMigrated: isMigrated
                } : {},
                embeddedMacroParentType: embeddedMacroParentType,
                embeddedMacroType: embeddedMacroType
            }
        }), [
        contentId,
        isInline,
        isMigrated,
        embeddedMacroParentType,
        embeddedMacroType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, children);
};
module.exports["ForgeUIEmbeddedMacroAnalyticsContext"] = $7e5b733cbcedd00c$export$2067d1940da125b6;

});

parcelRegister("lWtBU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1VhsF = parcelRequire("1VhsF");


var $4aRua = parcelRequire("4aRua");


var $9DHhW = parcelRequire("9DHhW");


var $6FQr4 = parcelRequire("6FQr4");

const $bb155dfc087093a5$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "forge.ui.extension.not.installed.title",
        defaultMessage: "App not available"
    },
    message: {
        id: "forge.ui.extension.not.installed.message",
        defaultMessage: "We can't display this content because the app isn't installed. Contact your administrator to install it."
    }
});
const $bb155dfc087093a5$export$8fa4e6bbdc2e95d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { extensionId: extensionId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId) {
        t1 = ()=>{
            (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
                source: "forgeUIRenderer",
                extensionId: extensionId,
                reason: "not_installed"
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage($bb155dfc087093a5$var$messages.title);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t3,
            appearance: "warning",
            testId: "extension-not-installed"
        }, t4);
        $[7] = t3;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ extensionId: extensionId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
            source: 'forgeUIRenderer',
            extensionId: extensionId,
            reason: 'not_installed'
        });
    }, [
        createAnalyticsEvent,
        extensionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($bb155dfc087093a5$var$messages.title),
        appearance: "warning",
        testId: "extension-not-installed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message)));
};
module.exports["ExtensionNotInstalled"] = $bb155dfc087093a5$export$8fa4e6bbdc2e95d1;

});

parcelRegister("kKOjD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8yKod = parcelRequire("8yKod");


var $gKVSw = parcelRequire("gKVSw");

const $8b08db13a4c8c729$export$eea1b756e7867f29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { extension: extension, children: children } = t0;
    const extensionViewportSize = extension?.properties?.viewportSize;
    if (extensionViewportSize && (0, $iDrrr.fg)("confluence_forge_early_render_reserve_height")) {
        let t1;
        if ($[0] !== extensionViewportSize) {
            t1 = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
            $[0] = extensionViewportSize;
            $[1] = t1;
        } else t1 = $[1];
        const viewportSizeHeight = t1;
        if ((0, $8yKod.isCustomUI)(extension)) {
            let t2;
            if ($[2] !== viewportSizeHeight) {
                t2 = {
                    height: viewportSizeHeight
                };
                $[2] = viewportSizeHeight;
                $[3] = t2;
            } else t2 = $[3];
            let t3;
            if ($[4] !== children || $[5] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t2,
                    "data-testid": "reserved-height-wrapper-custom-ui"
                }, children);
                $[4] = children;
                $[5] = t2;
                $[6] = t3;
            } else t3 = $[6];
            return t3;
        } else {
            let t2;
            if ($[7] !== viewportSizeHeight) {
                t2 = {
                    minHeight: viewportSizeHeight
                };
                $[7] = viewportSizeHeight;
                $[8] = t2;
            } else t2 = $[8];
            let t3;
            if ($[9] !== children || $[10] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t2,
                    "data-testid": "reserved-height-wrapper-uikit"
                }, children);
                $[9] = children;
                $[10] = t2;
                $[11] = t3;
            } else t3 = $[11];
            return t3;
        }
    }
    let t1;
    if ($[12] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[12] = children;
        $[13] = t1;
    } else t1 = $[13];
    return t1;
} : ({ extension: extension, children: children })=>{
    const extensionViewportSize = extension?.properties?.viewportSize;
    // Only apply reserved height if the feature flag is on AND viewportSize is defined
    if (extensionViewportSize && (0, $iDrrr.fg)('confluence_forge_early_render_reserve_height')) {
        const viewportSizeHeight = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
        // Custom UI extensions have full support for viewportSize, leading to a strict height.
        // UI Kit 2 extensions, while they can define viewportSize in their manifest, primarily
        // have dynamic sizing. This means viewportSize is not a strict constraint for them as it
        // is for Custom UI. Using minHeight based on a manifest-defined viewportSize is therefore
        // a best-effort approach to proactively reserve space. This aims to reduce layout shift
        // while still allowing the extension to grow dynamically if its content requires more space.
        if ((0, $8yKod.isCustomUI)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-custom-ui"
        }, children);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                minHeight: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-uikit"
        }, children);
    }
    // If FF is off, or if viewportSize is undefined, render children directly
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ReservedHeightWrapper"] = $8b08db13a4c8c729$export$eea1b756e7867f29;

});

parcelRegister("gKVSw", function(module, exports) {
const $16b1ea7c28597489$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $16b1ea7c28597489$export$d27eb2c49eeaf1b4 = (size)=>{
    return $16b1ea7c28597489$var$macroHeights[size ?? 'default'];
};
module.exports["calculateViewportSizeHeight"] = $16b1ea7c28597489$export$d27eb2c49eeaf1b4;

});

parcelRegister("a005x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $fTCJP = parcelRequire("fTCJP");


var $DIyeF = parcelRequire("DIyeF");


var $6FQr4 = parcelRequire("6FQr4");

const $8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionKey: extensionKey, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    let t1;
    let t2;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== extensionKey) {
        t1 = ()=>{
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: analyticsSource,
                extensionKey: extensionKey
            });
        };
        t2 = [
            analyticsSource,
            createAnalyticsEvent,
            extensionKey
        ];
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = extensionKey;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionKey: extensionKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: analyticsSource,
            extensionKey: extensionKey
        });
    }, [
        analyticsSource,
        createAnalyticsEvent,
        extensionKey
    ]);
    return null;
};
const $8c747d61f3d69552$export$22c58ed2c6d282da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentId: contentId, embeddedMacroParentType: t1, embeddedMacroType: t2, extensionKey: extensionKey, isInline: isInline, source: source } = t0;
    const embeddedMacroParentType = t1 === undefined ? "UIKit" : t1;
    const embeddedMacroType = t2 === undefined ? "productMacroCore" : t2;
    let t3;
    if ($[0] !== extensionKey || $[1] !== source) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionKey: extensionKey,
            source: source
        });
        $[0] = extensionKey;
        $[1] = source;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== contentId || $[5] !== embeddedMacroParentType || $[6] !== embeddedMacroType || $[7] !== isInline || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedMacroType: embeddedMacroType,
            isInline: isInline
        }, t3, children);
        $[3] = children;
        $[4] = contentId;
        $[5] = embeddedMacroParentType;
        $[6] = embeddedMacroType;
        $[7] = isInline;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, contentId: contentId, embeddedMacroParentType: embeddedMacroParentType = 'UIKit', embeddedMacroType: embeddedMacroType = 'productMacroCore', extensionKey: extensionKey, isInline: isInline, source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedMacroType: embeddedMacroType,
        isInline: isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionKey: extensionKey,
        source: source
    }), children);
};
module.exports["ForgeUIBodiedMacroEmbeddedContentAnalytics"] = $8c747d61f3d69552$export$22c58ed2c6d282da;

});

parcelRegister("4G9b9", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27 = (cloudId, userId)=>new (0, $kwzZh.default)({
        providers: [
            {
                url: '/gateway/api/emoji/standard'
            },
            {
                url: '/gateway/api/emoji/atlassian'
            },
            {
                url: `/gateway/api/emoji/${cloudId}/site`
            }
        ],
        currentUser: userId ? {
            id: userId
        } : undefined
    }).getEmojiProvider();
module.exports["getEmojiProvider"] = $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27;

});

parcelRegister("35FNt", function(module, exports) {
const $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE = 'xen:macro';
const $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT = '/static/';
const $28462bf0a1463e2a$export$10e34576c0b0b7c2 = (extensionId)=>{
    if (!extensionId) return;
    const staticModuleKeyIndex = extensionId.indexOf($28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT);
    if (staticModuleKeyIndex === -1) return;
    return extensionId.slice(staticModuleKeyIndex + $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT.length);
};
const $28462bf0a1463e2a$export$157b3a147b626a8d = (forgeMacroExtensions, extensionKey)=>{
    if (!extensionKey || !forgeMacroExtensions) return;
    return forgeMacroExtensions.find((extension)=>extension.type === $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE && Boolean(extension.migrationKey) && $28462bf0a1463e2a$export$10e34576c0b0b7c2(extension.id) === extensionKey);
};
const $28462bf0a1463e2a$export$2d02be23603c7977 = (extension)=>{
    if (extension?.properties?.layout === 'inline') return 'inlineExtension';
    return undefined;
};
const $28462bf0a1463e2a$export$32ee00d981bcfb18 = ({ accountId: accountId, cloudId: cloudId, extension: extension, extensionData: extensionData, productContextIds: productContextIds, props: props })=>{
    if (!cloudId || !productContextIds || !accountId) return;
    const parameters = {
        ...props.parameters ?? {}
    };
    const guestParams = {
        ...parameters.guestParams ?? {}
    };
    Object.entries(parameters.macroParams ?? {}).forEach(([key, macroParam])=>{
        if (typeof guestParams[key] === 'undefined') guestParams[key] = macroParam?.value;
    });
    return {
        ...parameters,
        embeddedMacroContext: {
            ...parameters.embeddedMacroContext,
            accountId: parameters.embeddedMacroContext?.accountId ?? accountId,
            cloudId: parameters.embeddedMacroContext?.cloudId ?? cloudId,
            contextIds: parameters.embeddedMacroContext?.contextIds ?? productContextIds,
            extensionData: parameters.embeddedMacroContext?.extensionData ?? extensionData
        },
        extensionId: parameters.extensionId ?? extension.id,
        extensionTitle: parameters.extensionTitle ?? (typeof extension.properties?.title === 'string' ? extension.properties.title : undefined),
        guestParams: guestParams,
        layout: parameters.layout ?? $28462bf0a1463e2a$export$2d02be23603c7977(extension)
    };
};
module.exports["getMigratedForgeMacroExtension"] = $28462bf0a1463e2a$export$157b3a147b626a8d;
module.exports["createForgeParametersForConnectMacro"] = $28462bf0a1463e2a$export$32ee00d981bcfb18;

});

parcelRegister("2Ni8p", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR = '[data-forge-extension-container]';
const $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION = 160;
// Ignore subpixel differences from zoom and layout rounding to avoid ResizeObserver churn.
const $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX = 1;
const $b7e4f66189f2b64b$export$6624bbff07c1eebb = 32;
const $b7e4f66189f2b64b$var$isExtensionNode = (node)=>node.type === 'extension' || node.type === 'bodiedExtension' || node.type === 'inlineExtension';
const $b7e4f66189f2b64b$var$getTableColumnCount = (tableNode)=>{
    if (!Array.isArray(tableNode.content)) return 0;
    return tableNode.content.reduce((maxColumns, row)=>{
        if (row.type !== 'tableRow' || !Array.isArray(row.content)) return maxColumns;
        const columns = row.content.reduce((count, cell)=>{
            const colspan = typeof cell.attrs?.colspan === 'number' ? cell.attrs.colspan : 1;
            return count + colspan;
        }, 0);
        return Math.max(maxColumns, columns);
    }, 0);
};
const $b7e4f66189f2b64b$export$ad52afba6f15d589 = (node)=>{
    if (!node || typeof node !== 'object') return {
        containsExtension: false
    };
    const adfNode = node;
    const childAnalyses = adfNode.content?.map($b7e4f66189f2b64b$export$ad52afba6f15d589) ?? [];
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(adfNode) || childAnalyses.some((analysis)=>analysis.containsExtension);
    const childMinWidth = Math.max(0, ...childAnalyses.map((analysis)=>analysis.nestedExtensionTableMinWidth ?? 0));
    if (adfNode.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: childMinWidth || undefined
    };
    const columnCount = $b7e4f66189f2b64b$var$getTableColumnCount(adfNode);
    const currentWidth = typeof adfNode.attrs?.width === 'number' ? adfNode.attrs.width : 0;
    const minWidth = columnCount * $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION;
    return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: Math.max(childMinWidth, currentWidth, minWidth) || undefined
    };
};
const $b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal = (node, tableWidth)=>{
    const resizedChildren = node.content?.map((child)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(child, tableWidth));
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(node) || Boolean(resizedChildren?.some((child)=>child.containsExtension));
    const resizedContent = resizedChildren?.map((child)=>child.node);
    const resizedNode = resizedContent ? {
        ...node,
        content: resizedContent
    } : node;
    if (node.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        node: resizedNode
    };
    const currentWidth = typeof node.attrs?.width === 'number' ? node.attrs.width : 0;
    return {
        containsExtension: containsExtension,
        node: {
            ...resizedNode,
            attrs: {
                ...node.attrs,
                width: Math.max(currentWidth, tableWidth)
            }
        }
    };
};
const $b7e4f66189f2b64b$export$1677922b5cecc89e = (node, tableWidth)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(node, tableWidth).node;
const $b7e4f66189f2b64b$export$c258ed5f7aead2c7 = (minWidth, extensionContainerWidth)=>minWidth ? Math.max(minWidth, (extensionContainerWidth ?? 0) - $b7e4f66189f2b64b$export$6624bbff07c1eebb) : undefined;
const $b7e4f66189f2b64b$export$4d03f4495375fd0f = (enabled)=>{
    const rendererContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [extensionContainerWidth, setExtensionContainerWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!enabled) {
            setExtensionContainerWidth(undefined);
            return;
        }
        const rendererContainer = rendererContainerRef.current;
        const extensionContainer = rendererContainer?.closest($b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR);
        if (!rendererContainer || !extensionContainer) return;
        // Nested ADF can inherit a narrower saved width than the Forge host. Expand only when the
        // host currently offers more space, preserving the renderer width in every other case.
        const updateWidth = ()=>{
            const availableWidth = extensionContainer.getBoundingClientRect().width;
            const parentWidth = rendererContainer.parentElement?.getBoundingClientRect().width ?? 0;
            setExtensionContainerWidth(availableWidth > parentWidth + $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX ? Math.round(availableWidth) : undefined);
        };
        updateWidth();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(extensionContainer);
        if (rendererContainer.parentElement) resizeObserver.observe(rendererContainer.parentElement);
        return ()=>resizeObserver.disconnect();
    }, [
        enabled
    ]);
    return {
        extensionContainerWidth: extensionContainerWidth,
        rendererContainerRef: rendererContainerRef
    };
};
const $b7e4f66189f2b64b$var$setImportantStyles = (element, styles)=>{
    const isCurrent = Object.entries(styles).every(([property, value])=>element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important');
    if (isCurrent) return;
    // cloneNode preserves attributes, including inline styles. Update the detached declaration so
    // the live element is mutated once without discarding unrelated Atlaskit styles.
    const nextStyle = element.cloneNode(false).style;
    Object.entries(styles).forEach(([property, value])=>{
        nextStyle.setProperty(property, value, 'important');
    });
    element.style.cssText = nextStyle.cssText;
};
const $b7e4f66189f2b64b$export$ab610de09e5e6264 = (rendererContainerRef, tableWidth)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!tableWidth) return;
        const rendererContainer = rendererContainerRef.current;
        if (!rendererContainer) return;
        const applyTableWidth = ()=>{
            const tableContainers = rendererContainer.querySelectorAll('.pm-table-container');
            const width = `${tableWidth}px`;
            tableContainers.forEach((tableContainer)=>{
                const table = tableContainer.querySelector('table');
                const tableWrapper = tableContainer.querySelector('.pm-table-wrapper');
                const styleContainer = tableContainer.closest('[role="none"]');
                if (styleContainer) $b7e4f66189f2b64b$var$setImportantStyles(styleContainer, {
                    width: width,
                    'max-width': 'none',
                    'margin-inline-start': `${$b7e4f66189f2b64b$export$6624bbff07c1eebb}px`,
                    'margin-inline-end': '0px'
                });
                $b7e4f66189f2b64b$var$setImportantStyles(tableContainer, {
                    width: width,
                    'max-width': 'none'
                });
                if (tableWrapper) $b7e4f66189f2b64b$var$setImportantStyles(tableWrapper, {
                    width: width
                });
                if (table) $b7e4f66189f2b64b$var$setImportantStyles(table, {
                    width: width
                });
            });
        };
        applyTableWidth();
        const animationFrameId = typeof requestAnimationFrame === 'undefined' ? undefined : requestAnimationFrame(applyTableWidth);
        const mutationObserver = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(applyTableWidth);
        mutationObserver?.observe(rendererContainer, {
            attributeFilter: [
                'style'
            ],
            attributes: true,
            subtree: true
        });
        if (typeof ResizeObserver === 'undefined') return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
        };
        const resizeObserver = new ResizeObserver(applyTableWidth);
        resizeObserver.observe(rendererContainer);
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        rendererContainerRef,
        tableWidth
    ]);
};
module.exports["NESTED_EXTENSION_TABLE_INLINE_START_OFFSET"] = $b7e4f66189f2b64b$export$6624bbff07c1eebb;
module.exports["getNestedExtensionTableAnalysis"] = $b7e4f66189f2b64b$export$ad52afba6f15d589;
module.exports["resizeNestedExtensionTables"] = $b7e4f66189f2b64b$export$1677922b5cecc89e;
module.exports["getNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$c258ed5f7aead2c7;
module.exports["useForgeExtensionContainerWidth"] = $b7e4f66189f2b64b$export$4d03f4495375fd0f;
module.exports["useNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$ab610de09e5e6264;

});


//# sourceMappingURL=ByLineForgeApp.daa085c5.js.map
